import Container from '@mui/material/Container';
import { Help } from '../features/help';
import { PAGES_ANALYTICS_TITLES } from '../utils/enums';
import { PageHelmet } from '../components';

const HelpPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.HELP}>
    <Container
      sx={{
        px: { xs: 1, lg: 2 },
      }}
      maxWidth={false}
    >
      <Help />
    </Container>
  </PageHelmet>
);

export default HelpPage;
